var angular = require('angular')

angular.module('AemCspsDpsPension')
  .factory('generatorDataservice', generatorDataservice)

generatorDataservice.$inject = []

function generatorDataservice () {
  var self = {
    value: value
  }

  function value (valueName, params, defaults) {
    var val = defaults
    val.value = val.default
    try {
      if (angular.isDefined(params[valueName].min)) {
        val.min = params[valueName].min
      }
    } catch (e) {}
    try {
      if (angular.isDefined(params[valueName].max)) {
        val.max = params[valueName].max
      }
    } catch (e) {}
    try {
      if (angular.isDefined(params[valueName].default)) {
        val.default = params[valueName].default
        val.value = val.default
      }
    } catch (e) {}
    try {
      if (angular.isDefined(params[valueName].step)) {
        val.step = params[valueName].step
      }
    } catch (e) {}
    return val
  }

  return self
}
